import { Button } from 'antd';
import React from 'react';
import Btn from '../../../../../../../components/btn';
import styles from '../CreateNewWorkScheduleByPeriod.module.scss';
import { workScheduleByPeriodFormModes } from '../CreateNewWorkScheduleByPeriod.constants';

const submitTextByMode = {
  [workScheduleByPeriodFormModes.create]: 'Сохранить и продолжить',
  [workScheduleByPeriodFormModes.edit]: 'Сохранить и продолжить',
  [workScheduleByPeriodFormModes.duplicate]: 'Сохранить копию и продолжить',
};

export const FormFooter = ({
  mode = workScheduleByPeriodFormModes.create,
  submitDisabled = false,
  submitText,
  onCancel,
}) => (
  <div className={styles.footer}>
    <Button className={styles.cancelButton} onClick={onCancel}>
      Отмена
    </Button>
    <Btn htmlType="submit" type="primary" disabled={submitDisabled}>
      {submitText || submitTextByMode[mode] || submitTextByMode.create}
    </Btn>
  </div>
);
